import React from 'react';
import * as classnames from 'classnames';
import UserAvatar from './Avatar';
import UserName from './Name';
import UserEmail from './Email';
import UserEdit from './Edit';

import './styles.scss';

const User = ({ user: { firstName, lastName, avatar, email},isCurrent, withEmail, isEdit, isEditImg, isLight, isBig, ...props }) => {

	return (
		<div
			className={
				classnames('user', {
					'user--light': isLight,
					'user--big': isBig
				})
			}
		>
			<UserAvatar avatar={avatar}/>
			<div className="user__info">
				<UserName name={{firstName,lastName}} isCurrent={isCurrent}/>
				{withEmail && <UserEmail email={email}/>}
				{isEdit && <UserEdit isEdit/>}
				{isEditImg && <UserEdit isEditImg/>}
			</div>
		</div>
	)
};

export default User;
